module.exports = __webpack_public_path__ + "img/gzr.a57dd02b.svg";